import CommonButton from 'components/shared/FormComponents/V2/commonV2/CommonButton';
import OnboardHeader from 'components/shared/SubAdminOnboard/OnboardHeader'
import { Form, Formik } from 'formik';
import React, { useEffect, useState } from 'react'
import onboardSchema from './onboard.schema';
import { LeftArrowIcon, RightArrowIcon, RightArrowIconNew } from 'Assets/icons/V2';
import { useSelector } from 'react-redux';
import StepProgressBar from 'components/shared/SubAdminOnboard/StepProgressBar';
import CommonButtonNew from 'components/shared/FormComponents/V2/commonV2/CommonButtonNew';
import WelcomePage from 'components/shared/SubAdminOnboard/WelcomePage';
import Step1 from 'components/shared/SubAdminOnboard/Step1';
import { useGetProfileQuery, useUpdateOnboardMutation } from 'store/services/profile';
import { updateOnboardStep } from 'store/slices/authSlice';
import { useNavigate } from 'react-router-dom';

function SubAdminOnboard() {
    const userInfo = useSelector((state) => state.auth.userInfo)
    console.log("userInfo", userInfo)
    const navigate = useNavigate()

    const { data: subAdminDetails, isLoading } = useGetProfileQuery()
    const [updateOnboard, { data: onboardData, isLoading: onboardLoading, isFetching: onboardFetching }] = useUpdateOnboardMutation()

    const [step, setStep] = useState(userInfo?.on_board_step);
    const totalSteps = 1;

    useEffect(() => {
        if (!userInfo) return;

        if (userInfo.is_on_board_complete) {
            navigate('/');
            return;
        }
    }, [userInfo, navigate]);

    const initialValues = {
        firstname: subAdminDetails?.firstname || "",
        lastname: subAdminDetails?.lastname || "",
        email: subAdminDetails?.email || "",
        phone: Number(subAdminDetails?.phone) || "",
    };

    const handleBack = (formik) => {
        console.log(step)
        if (step > 0) {
            // Remove errors for the current step
            const nextErrors = { ...formik.errors };
            if (step === 3) {
                delete nextErrors.documents;
            }
            if (step === 4) {
                delete nextErrors.signature_img;
                delete nextErrors.email_signature;
            }
            formik.setErrors(nextErrors);

            setStep(step - 1);
        }
    };

    const getPayloadByStep = (step, values) => {
        switch (step) {
            case 1:
                return {
                    firstname: values?.firstname,
                    lastname: values?.lastname,
                    // email: values?.email,
                    phone: values?.phone?.toString(),
                };
            default:
                return {};
        }
    };

    const handleSubmit = async (values) => {
        if (step === 0) {
            setStep((prev) => prev + 1)
        }
        else {
            try {
                const payload = getPayloadByStep(step, values);
                const nextStepId = step;

                const resp = await updateOnboard({
                    data: payload,
                    id: nextStepId,
                });

                if (resp?.data?.data) {
                    const updatedStep = Number(resp.data.data.step);
                    const isComplete = resp.data.data.is_on_board_complete;
                    console.log("resp", updatedStep, isComplete)

                    dispatch(updateOnboardStep({
                        on_board_step: updatedStep + 1,
                        is_on_board_complete: isComplete,
                    }));

                    if (isComplete) {
                        navigate('/');
                    } else {
                        setStep(updatedStep + 1); // sync UI with backend
                    }
                }
            } catch (error) {
                console.error("Onboarding submit failed:", error);
            }
        }

    };

    const stepsData = [
        { title: "Review & Confirm Your Information" },
        { title: "Review & Agree to Khan’s Policies" },
        { title: "Add Documents" },
        { title: "Add Signature & Profile Image" },
    ];

    return (
        <div>
            <OnboardHeader />
            <Formik
                initialValues={initialValues}
                enableReinitialize
                validationSchema={onboardSchema(step)}
                onSubmit={handleSubmit}
            >
                {({ values, setFieldValue, handleSubmit, isValid, errors, setErrors, touched, submitCount }) => {
                    console.log("Formik values", values)

                    return (
                        <Form onSubmit={handleSubmit}>
                            <div className="d-flex flex-column align-items-center min-vh-100" style={{ background: "#93278F0F" }}>
                                <div className="col-lg-7 col-sm-9 col-12 px-3 pb-3 bg-white min-vh-100">
                                    <StepProgressBar totalSteps={totalSteps} currentStep={step} />

                                    <span className='profile-title-main'>PROFILE SETUP</span>
                                    {
                                        step === 0 ? <h2 className='onboard-welcome'>Welcome!</h2> : <h3 className='step-title'>
                                            <strong>Step {step}:</strong> {stepsData[step - 1]?.title}
                                        </h3>
                                    }

                                    {
                                        step === 0 && <WelcomePage />
                                    }
                                    {step === 1 && (
                                        <Step1
                                            data={subAdminDetails}
                                            values={values}
                                            setFieldValue={setFieldValue}
                                        />
                                    )}

                                    <div style={{ marginTop: "112px" }} className={`d-flex  pe-lg-5 ${step === 0 ? 'justify-content-end' : 'justify-content-between'} `}>
                                        {
                                            step > 0 &&
                                            <CommonButtonNew
                                                text={step === 1 ? 'Cancel' : 'Back'}
                                                onClick={() => handleBack({ errors, setErrors })}
                                                className="button-outlined"
                                                icon={step > 1 && <LeftArrowIcon />}
                                                iconPosition='left'
                                                type="button"
                                            />
                                        }


                                        <CommonButtonNew
                                            text={step === totalSteps ? 'Done' : 'Next'}
                                            className="button-filled"
                                            icon={step !== totalSteps && <RightArrowIconNew />}
                                            iconPosition='right'
                                            type="submit"
                                            loading={onboardLoading}
                                            disabled={!isValid}
                                        />
                                    </div>
                                </div>
                            </div>

                        </Form>
                    )
                }}

            </Formik>
        </div>
    )
}

export default SubAdminOnboard
